<template>
  <div>
    <CommonVCard>
      <div v-if="isRenderPlayerRegistrationInfo && teams.length">
        <div>
          <span class="grey--text pb-5"
            >{{ $t("player_registration.registration_for") }}:</span
          >
          <h2 class="registration-form__header mb-1">
            {{ playerRegistrationInfo.registrationName }}
          </h2>
          <span
            v-if="!isRenderFieldsForCustomTeam"
            class="font-weight-medium"
            >{{ renderOrgUnitName }}</span
          >
        </div>
        <CommonPlayerProfileFormField
          v-if="isRenderFieldsForCustomTeam"
          :changeFormField="handleChangeTeam"
          :fieldValue="teamRegistration"
          :items="teams"
          :label="selectOption"
          :rules="{
            required: {
              value: 0
            }
          }"
          :type="RegistrationAnswerType.OPTIONS_CHOOSE_ONE"
          name="team"
        />
      </div>
      <div v-else class="d-flex justify-center">
        <v-progress-circular
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </CommonVCard>
    <CommonVCard
      v-if="
        playerRegistrationInfo.registrationType === 'EVENT' &&
          eventOptionEvents.length > 0
      "
    >
      <div>
        <v-row class="pb-5">
          <v-spacer />
          <div class="registration-form__header">
            Event option <b>{{ teamRegistration.name }}</b> registers you for
            {{ eventOptionEvents.length }}
            {{ eventOptionEvents.length === 1 ? "event" : "events" }}.
          </div>
          <v-spacer />
        </v-row>
        <div>
          <table>
            <tr class="pa-1">
              <th class="pa-1 text-left">
                Event
              </th>
              <th class="pa-1 text-left">
                Date
              </th>
              <th class="pa-1 text-left">
                Start
              </th>
              <th class="pa-1 text-left">
                End
              </th>
              <th class="pa-1 text-left">
                Venue
              </th>
            </tr>
            <tr v-for="event in eventOptionEvents" :key="event.id">
              <td class="pa-1">
                {{ event.name }}
              </td>
              <td class="pa-1">
                {{ new Date(event.start).toLocaleDateString() }}
              </td>
              <td class="pa-1">
                {{
                  new Date(event.start).toLocaleTimeString([], {
                    hour: "numeric",
                    minute: "2-digit"
                  })
                }}
              </td>
              <td class="pa-1">
                {{
                  new Date(event.end).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit"
                  })
                }}
              </td>
              <td class="pa-1">
                {{ event.venue }}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </CommonVCard>
  </div>
</template>

<script>
import CommonVCard from "./CommonVCard";
import CommonPlayerProfileFormField from "./CommonPlayerProfileFormField";
import { ModuleTypes } from "../../../store/ModuleTypes";
import { mapGetters, mapMutations } from "vuex";
import { RegistrationAnswerType } from "../enums/AnswerType";
import { RegistrationTypes } from "@/views/academy/enums/RegistrationTypes.ts";

export default {
  name: "PlayerRegistrationFormTeamCard",
  components: { CommonVCard, CommonPlayerProfileFormField },
  data: () => ({
    RegistrationAnswerType,
    teams: [],
    eventOptionEvents: []
  }),

  mounted() {
    if (this.playerRegistrationInfo.registrationType === "TEAM") {
      this.teams = this.playerRegistrationInfo.registrationOptions?.map(
        ({ id, name }) => ({ name, value: id })
      );
    } else {
      // If this is an Event Registration, isAvailable is true if the max allowed registrations have not been reached.
      this.teams = this.playerRegistrationInfo.registrationOptions?.map(
        ({ id, name, isAvailable }) => ({
          name,
          value: id,
          disabled: !isAvailable
        })
      );
      if (!this.teams.find(t => !t.disabled)) {
        // if there are no options available, do not show the registration form. Notify the user and let them return to their dashboard.
        this.setAllEventOptionsAtCapacity({ allEventOptionsAtCapacity: true });
      }
    }
  },

  computed: {
    ...mapGetters(ModuleTypes.PLAYER_REGISTRATION, [
      "playerRegistration",
      "playerRegistrationDetails",
      "playerRegistrationInfo",
      "teamRegistration",
      "allEventOptionsAtCapacity"
    ]),

    isRenderPlayerRegistrationInfo() {
      return this.playerRegistrationInfo.registrationOptions?.length;
    },

    isRenderFieldsForCustomTeam() {
      return !this.$route.params?.orgUnitId;
    },

    renderOrgUnitName() {
      return this.playerRegistrationInfo.registrationOptions?.[0]?.name;
    },

    selectOption() {
      return this.playerRegistrationInfo.registrationType ===
        RegistrationTypes.TEAM
        ? "Select Team"
        : "Select Event";
    }
  },
  methods: {
    ...mapMutations(ModuleTypes.PLAYER_REGISTRATION, [
      "setPlayerRegistration",
      "setTeamRegistration",
      "setAllEventOptionsAtCapacity"
    ]),

    handleChangeTeam(e) {
      this.$emit("registrationOptionSelected");
      this.setTeamRegistration({
        teamRegistration: {
          value: e,
          name: this.playerRegistrationInfo.registrationOptions.find(
            item => item.id === e
          )?.name
        }
      });
      if (this.playerRegistration) {
        this.setPlayerRegistration({ playerRegistration: {} });
      }
    }
  },
  watch: {
    "teamRegistration.value": {
      handler: function(newVal, oldVal) {
        if (
          newVal !== null &&
          newVal !== oldVal &&
          this.playerRegistrationInfo.registrationType === "EVENT"
        ) {
          this.eventOptionEvents = this.playerRegistrationInfo.registrationOptions?.find(
            ro => ro.id === this.teamRegistration.value
          ).events;
        }
      }
    }
  }
};
</script>

<style scoped>
.registration-form__header {
  font-size: 18px;
  font-weight: 500;
  color: var(--dark-color);
}
</style>
